import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const HeaderWrap = styled.header`
  width: 100%;
  position: relative;
`;

export const HeaderFixed = styled.div`
  position: fixed;
  height: 71px;
  z-index: 4;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0 10px 80px;
  background-color: #fff;
  border-bottom: 1px solid #bddee3;
  max-width: 1020px;
  width: calc(100% - 260px);
  padding-right: 28px;
`;

export const LogoutWrapper = styled.div`
  margin-left: auto;
  display: flex;
`;

export const Button = styled(Link)`
  font-weight: bold;
  font-size: 14px;
  line-height: 20px;
  color: rgba(9, 21, 38, 0.35);
  cursor: pointer;
  &:hover {
    color: rgba(9, 21, 38, 0.65);
  }
`;
